import React from "react";

export default function BlogGallery({ images, onImageClick }) {
  if (!images || images.length === 0) {
    return null;
  }

  return (
    <div className="col-12 mt-4 pt-3 border-top">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="section-title mb-0">Photo Gallery</h3>
        <small className="text-muted">
          <i className="ti-eye mr-1" /> Click any photo to expand & browse
        </small>
      </div>

      <div className="row">
        {images.map((image, index) => (
          <div key={index} className="col-lg-4 col-md-6 mb-4">
            <div
              className="card border-0 rounded-0 hover-shadow h-100 position-relative"
              style={{ cursor: "pointer", overflow: "hidden" }}
              onClick={() => onImageClick && onImageClick(index)}
              title="Click to expand & browse photos"
            >
              <div className="position-relative" style={{ height: "220px" }}>
                <img
                  src={image.url}
                  alt={
                    image.description ||
                    image.title ||
                    `Gallery image ${index + 1}`
                  }
                  className="card-img-top rounded-0 w-100 h-100"
                  style={{
                    objectFit: "cover",
                    transition: "transform 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.05)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    backgroundColor: "rgba(26, 26, 55, 0.7)",
                    color: "#ffffff",
                    borderRadius: "50%",
                    width: "32px",
                    height: "32px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "14px",
                  }}
                >
                  <i className="ti-zoom-in" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
